import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./PlanProduct.module.css";

const DEFAULTS = {
  client: { email: "client@example.com", password: "client123" },
  consultant: { email: "consultant@example.com", password: "consult123" },
};

export default function PlanProduct() {
  const [activeTab, setActiveTab] = useState("client");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const labels = useMemo(
    () => ({
      client: { tab: "Client Login", cta: "Access Client" },
      consultant: { tab: "Consultant", cta: "Launch Consultant" },
    }),
    []
  );

  const handleSubmit = (role) => (e) => {
    e.preventDefault();
    if (role === "consultant") {
      navigate("/plan-product/consultant");
      return;
    }
    navigate("/plan-product/client");
  };

  return (
    <div className={styles.root}>
      <div className={styles.pageBg} aria-hidden="true">
        <div className={`${styles.glow} ${styles.glowBlue}`} />
        <div className={`${styles.glow} ${styles.glowPurple}`} />
      </div>

      <main className={styles.shell}>
        <header className={styles.brand}>
          <div className={styles.logo}>
            <div className={styles.logoInner}>OS</div>
          </div>
          <div className={styles.brandText}>
            <h1>OptiStock Portal</h1>
            <p>Select your workspace</p>
          </div>
        </header>

        <section className={styles.card}>
          <div className={styles.tabs} role="tablist" aria-label="Workspace type">
            {["client", "consultant"].map((role) => (
              <button
                key={role}
                type="button"
                id={`plan-product-tab-${role}`}
                role="tab"
                className={`${styles.tab} ${activeTab === role ? styles.tabActive : ""}`}
                aria-selected={activeTab === role}
                aria-controls={`plan-product-panel-${role}`}
                onClick={() => {
                  setActiveTab(role);
                  setStatus("");
                }}
              >
                {labels[role].tab}
              </button>
            ))}
          </div>

          <div className={styles.divider} />

          <form
            id="plan-product-panel-client"
            role="tabpanel"
            aria-labelledby="plan-product-tab-client"
            className={`${styles.form} ${activeTab === "client" ? styles.formActive : ""}`}
            noValidate
            onSubmit={handleSubmit("client")}
            hidden={activeTab !== "client"}
          >
            <label>
              EMAIL
              <div className={styles.input}>
                <span className={styles.icon}>@</span>
                <input type="email" name="email" defaultValue={DEFAULTS.client.email} required />
              </div>
            </label>
            <label>
              PASSWORD
              <div className={styles.input}>
                <span className={styles.icon}>*</span>
                <input type="password" name="password" defaultValue={DEFAULTS.client.password} required />
              </div>
            </label>
            <button type="submit" className={styles.cta}>
              <span>{labels.client.cta}</span>
              <span className={styles.arrow} aria-hidden="true">
                &#8250;
              </span>
            </button>
          </form>

          <form
            id="plan-product-panel-consultant"
            role="tabpanel"
            aria-labelledby="plan-product-tab-consultant"
            className={`${styles.form} ${activeTab === "consultant" ? styles.formActive : ""}`}
            noValidate
            onSubmit={handleSubmit("consultant")}
            hidden={activeTab !== "consultant"}
          >
            <label>
              EMAIL
              <div className={styles.input}>
                <span className={styles.icon}>@</span>
                <input type="email" name="email" defaultValue={DEFAULTS.consultant.email} required />
              </div>
            </label>
            <label>
              PASSWORD
              <div className={styles.input}>
                <span className={styles.icon}>*</span>
                <input
                  type="password"
                  name="password"
                  defaultValue={DEFAULTS.consultant.password}
                  required
                />
              </div>
            </label>
            <button type="submit" className={styles.cta}>
              <span>{labels.consultant.cta}</span>
              <span className={styles.arrow} aria-hidden="true">
                &#8250;
              </span>
            </button>
          </form>

          {status ? <div className={styles.status}>{status}</div> : null}
        </section>
      </main>
    </div>
  );
}
